import React, { Component } from 'react'
import '../Common.scss';
import styles from './LooseFurniture.module.scss';
import defaultImage from '../../../assets/default.png';

export default class LooseFurniture extends Component<any,any> {
  render() {
        const { pageDetails } = this.props;
        const {looseFurnitureList} = pageDetails || {};
        return (    
                <>
                    <div className="page-heading">{pageDetails?.name}</div>
                        <div className={styles["appliances-details"]}>
                        {
                            <div className={styles["details-table-app"]}>
                                 <div className={styles["table-row-app"] + " "+ styles['headings']}>
                                 <div className={styles["table-cell-app"]}>
                                        {"Image"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Name"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Supplied By"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Installed By"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Description"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Cutting Dimension"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"Quantity"}
                                    </div>
                                </div>
                                {
                                    (looseFurnitureList || []).map((appliance, index)=>{
                                        let {scope, item, installationBy, looseFurnitureName, description, cuttingDimension='NA',count} = appliance;
                                        let {imageUrl} = item;
                                        
                                        return(
                                            <div className={styles["table-row-app"]}>
                                                <div className={styles["table-cell-app"]}>
                                                    <img crossOrigin="anonymous" alt="loose furniture"style={{paddingTop: "0px"}} src={imageUrl ? `${imageUrl.includes('homelanestore.com') || imageUrl.includes('spacecraft-backend') ? imageUrl : 'https://www.homelanestore.com/media/'+imageUrl}?ver=${new Date().getTime()}` : defaultImage} width="50x" height="35px" />
                                                </div>
                                                 <div className={styles["table-cell-app"]}>
                                                    <span>{item?.name?item?.name:looseFurnitureName}</span>
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                    {scope}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                 {installationBy}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {`${description ? description.toString():"NA"}`}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {`${cuttingDimension ? cuttingDimension : "NA"}`}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {count}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                </>      
    )
  }
}
